import React from 'react';

const Index = (props) => {
  return (
    <div
      className={[
        'relative border border-gray-200 rounded-lg p-4 flex justify-center items-center  gap-2 hover:scale-105 transition-all duration-300 hover:shadow-lg hover:shadow-gray-200',
        props.item.name === 'React Native'
          ? 'flex gap-2 md:flex-row flex-col'
          : 'flex-col',
      ].join(' ')}>
      <img
        src={props.item.image}
        alt={props.item.name}
        className={[
          'object-contain',
          props.item.name === 'React Native' ? 'h-24' : 'h-24 ',
        ].join(' ')}
      />
      {props.item.name === 'React Native' ? (
        <p className=" text-base lg:text-2xl">React Native</p>
      ) : (
        ''
      )}
    </div>
  );
};

export default React.memo(Index);
